import React from "react";
import { Table } from "reactstrap";

const calendarData = [
  { id: 1,  name: "Accounting & Finance Category",                              file: "ACCOUNTING & FINANCE CATEGORY.pdf" },
  { id: 2,  name: "Agribusiness Sustainability Category",                       file: "AGRIBUSINESS SUSTAINABILITY CATEGORY.pdf" },
  { id: 3,  name: "Artificial Intelligence Category",                           file: "ARTIFICIAL INTELLIGENCE CATEGORY.pdf" },
  { id: 4,  name: "Audit, Compliance and Governance Category",                  file: "AUDIT, COMPLIANCE AND GOVERNANCE CATEGORY.pdf" },
  { id: 5,  name: "Banking, Investment & Insurance Category",                   file: "BANKING, INVESTMENT & INSURANCE CATEGORY.pdf" },
  { id: 6,  name: "Communication and Writing Skills Category",                  file: "COMMUNICATION AND WRITING SKILLS CATEGORY.pdf" },
  { id: 7,  name: "Construction Management & Civil Engineering Category",       file: "CONSTRUCTION MANAGEMENT & CIVIL ENGINEERING CATEGORY.pdf" },
  { id: 8,  name: "Contract Management & Law Category",                         file: "CONTRACT MANAGEMENT & LAW CATEGORY.pdf" },
  { id: 9,  name: "Customer Service Category",                                  file: "CUSTOMER SERVICE CATEGORY.pdf" },
  { id: 10, name: "Data Management & Business Intelligence Category",           file: "DATA MANAGEMENT & BUSINESS INTELLIGENCE CATEGORY.pdf" },
  { id: 11, name: "Electrical Engineering Category",                            file: "ELECTRICAL ENGINEERING CATEGORY.pdf" },
  { id: 12, name: "Health, Safety & Environment Category",                      file: "HEALTH, SAFETY & ENVIRONMENT CATEGORY.pdf" },
  { id: 13, name: "Human Resource Management Category",                         file: "HUMAN RESOURCE MANAGEMENT CATEGORY.pdf" },
  { id: 14, name: "Humanitarian Development Category",                          file: "HUMANITARIAN DEVELOPMENT CATEGORY.pdf" },
  { id: 15, name: "Instrumentation & Process Control Category",                 file: "INSTRUMENTATION & PROCESS CONTROL CATEGORY.pdf" },
  { id: 16, name: "Leadership & Management Category",                           file: "LEADERSHIP & MANAGEMENT CATEGORY.pdf" },
  { id: 17, name: "Learning & Development Category",                            file: "LEARNING & DEVELOPMENT CATEGORY.pdf" },
  { id: 18, name: "Maintenance Engineering Category",                           file: "MAINTENANCE ENGINEERING CATEGORY.pdf" },
  { id: 19, name: "Mechanical Engineering Category",                            file: "MECHANICAL ENGINEERING CATEGORY.pdf" },
  { id: 20, name: "Media & Telecom Category",                                   file: "MEDIA & TELECOM CATEGORY.pdf" },
  { id: 21, name: "National Security Management Category",                      file: "NATIONAL SECURITY MANAGEMENT CATEGORY.pdf" },
  { id: 22, name: "Office Administration Category",                             file: "OFFICE ADMINISTRATION CATEGORY.pdf" },
  { id: 23, name: "Oil & Gas Category",                                         file: "OIL & GAS CATEGORY.pdf" },
  { id: 24, name: "Personal & Professional Development Category",               file: "PERSONAL & PROFESSIONAL CATEGORY.pdf" },
  { id: 25, name: "Procurement, Logistics & Supply Chain Management Category",  file: "PROCUREMENT, LOGISTICS & SUPPLY CHAIN MANAGEMENT CATEGORY.pdf" },
  { id: 26, name: "Project Management Category",                                file: "PROJECT MANAGEMENT CATEGORY.pdf" },
  { id: 27, name: "Public Private Partnerships (PPP) Category",                 file: "PUBLIC PRIVATE PARTNERSHIPS (PPP) CATEGORY.pdf" },
  { id: 28, name: "Public Relations Category",                                  file: "PUBLIC RELATIONS CATEGORY.pdf" },
  { id: 29, name: "Public Sector Management Category",                          file: "PUBLIC SECTOR MANAGEMENT CATEGORY.pdf" },
  { id: 30, name: "Quality Control & Risk Management Category",                 file: "QUALITY CONTROL & RISK MANAGEMENT CATEGORY.pdf" },
  { id: 31, name: "Sales & Marketing Category",                                 file: "SALES & MARKETING CATEGORY.pdf" },
  { id: 32, name: "Ships & Ports Management Category",                          file: "SHIPS & PORTS MANAGEMENT CATEGORY.pdf" },
  { id: 33, name: "Strategy & Strategic Planning Category",                     file: "STRATEGY & STRATEGIC PLANNING CATEGORY.pdf" },
  { id: 34, name: "Tax & Revenue Category",                                     file: "TAX & REVENUE CATEGORY.pdf" },
];

export default function OverseasTrainingTable2026() {
  return (
    <Table striped style={{ borderTop: "none", textAlign: "left" }}>
      <thead>
        <tr>
          <th style={{ fontSize: "16px" }}>#</th>
          <th style={{ fontSize: "16px" }}>DOCUMENT</th>
          <th style={{ fontSize: "16px", textAlign: "right" }}>DOWNLOAD</th>
        </tr>
      </thead>
      <tbody>
        {calendarData.map((item, index) => (
          <tr key={item.id}>
            <th>{index + 1}</th>
            <th>{item.name}</th>
            <td style={{ textAlign: "right" }}>
              <a
                href={`/calendar/2026/${item.file}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i
                  className="fa fa-eye mr-4"
                  style={{ cursor: "pointer" }}
                  aria-hidden="true"
                />
              </a>
              <a
                href={`/calendar/2026/${item.file}`}
                download={item.file}
              >
                <i
                  className="fa fa-download mr-3"
                  style={{ cursor: "pointer" }}
                  aria-hidden="true"
                />
              </a>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}
